import { History } from "../api";

// Fetch the historical inforamtion from the api and add to the redux store
export const fetchHistory = (startDate, endDate, page = 1) => (dispatch) => {
  dispatch(setHistoryLoading());

  const start = startDate.format("YYYY-MM-DD"); // 2 years ago
  const end = endDate.format("YYYY-MM-DD"); // today

  return History.getWhere(start, end, page)
    .then((response) => {
      dispatch(setHistoryLinks(response.data.meta));
      dispatch(setHistoryList(response.data.data));
      dispatch(setHistoryLoaded());
    })
    .catch((e) => {
      const error = Array.isArray(e.errors) ? e.errors[0] : "Sorry, an error occurred";
      dispatch(setHistoryError(error));
      return { error };
    });
};

export const setHistoryLoading = () => ({
  type: "SET_HISTORY_LOADING",
});

export const setHistoryLoaded = () => ({
  type: "SET_HISTORY_LOAD_COMLETE",
});

export const setHistory = (history) => ({
  type: "SET_HISTORY",
  history,
});

export const setHistoryList = (list) => ({
  type: "SET_HISTORY_LIST",
  list,
});

export const setHistoryLinks = (meta) => ({
  type: "SET_HISTORY_LINKS",
  meta,
});

export const setHistoryError = (message = "Sorry, an error occurred") => ({
  type: "SET_HISTORY_ERROR",
  message,
});
